<template>
  <div class="document-toolbar">
    <div class="document-toolbar__set">
      <button
        class="document-toolbar__button"
        :class="{ _active: this.currentView === 'html' }"
        :disabled="!formatHtmlAvailable"
        title="Показать текст документа"
        @click="onButtonViewClick('html')"
      >
        <svg class="document-toolbar__icon _doc-type" width="48" height="24">
          <use xlink:href="#document--text" />
        </svg>
      </button>

      <button
        class="document-toolbar__button"
        :class="{ _active: this.currentView === 'scan' }"
        :disabled="!formatScanAvailable"
        title="Показать скан документа"
        @click="onButtonViewClick('scan')"
      >
        <svg class="document-toolbar__icon _doc-type" width="48" height="24">
          <use xlink:href="#document--scan" />
        </svg>
      </button>

      <button
        div class="document-toolbar__button" 
        :class= "{ _active: this.currentView === 'card', _card_highlighted: card.hasAnnotation && this.currentView != 'card'}"
        title="Показать полную карточку документа" 
        @click="onButtonViewClick('card')"
      >
        <svg class="document-toolbar__icon" width="22" height="22">
          <use xlink:href="#document--card" />
        </svg>
      </button>

      <button
        v-if="!bothViewsDisabled"
        class="document-toolbar__button"
        :class="{ _active: this.currentView === 'views' }"
        title="Сравнить виды документа"
        @click="onButtonViewClick('views')"
      >
        <svg class="document-toolbar__icon" width="24" height="24">
          <use xlink:href="#document--compare" />
        </svg>
      </button>

      <button
        v-if="card.isAttachment"
        class="document-toolbar__button" 
        title="Скачать приложение к документу" 
        @click="attachmentDownload" 
      >
        <svg class="document-toolbar__icon _doc-type" width="20" height="20">
          <use xlink:href="#document--download" />
        </svg>
      </button>
    </div> 

    <div class="document-toolbar__set">
        <div v-if="card.isAttachment && this.currentView === 'scan'" class="document-toolbar__set">
          <button class="document-toolbar__button document-toolbar__status" >
            <span class="document-toolbar__status-text" 
              :class="{ attach_preview: true }" >
              {{ "Предварительный просмотр приложения." }}
            </span>
          </button>
        </div> 
           <!--
      <button
        class="document-toolbar__button"
        :class="{'_active': this.currentView === 'package'}"
        :disabled="true"
        title="Показать сборник документа"
      >
        <svg class="document-toolbar__icon" width="28" height="28">
          <use xlink:href="#document--package" />
        </svg>
      </button>

      <button
        class="document-toolbar__button"
        :class="{'_active': this.currentView === 'catalog'}"
        :disabled="true"
        title="Показать каталожные листы документа"
      >
        <svg class="document-toolbar__icon" width="26" height="26">
          <use xlink:href="#catalog-lists" />
        </svg>
      </button>
-->

      <div v-if="card && !card.isChange" class="document-toolbar__set">
        <button
          class="document-toolbar__button document-toolbar__status" 
          :title="card.statusHint"
        >
          <svg class="document-toolbar__icon" width="24" height="24">
            <use :xlink:href= "statusIcon" />
          </svg>
          <div v-if="card.isRevision">
            <span class="document-toolbar__status-text"
                  :class="{ revision: true }" >
              {{ "Неосновная редакция." }}
            </span>
          </div>  
          <div v-else>
            <span class="document-toolbar__status-text">
              {{ statusName }}
            </span>
          </div>  
        </button>
      </div>

      <div v-if="card && !card.isChange && card.isRevision && card.parentDocumentId != null" class="document-toolbar__set">
        <button
          class="document-toolbar__button"
          title="Открыть текст основной редакции"
        >
          <div>
            <span class="document-toolbar__status-text"
                :class="{ revision: true }" >
              <router-link :to="makeDocumentRoute(card.parentDocumentId)">
              {{"Для перехода к основной редакции нажмите здесь"}} </router-link>
            </span>
          </div>        
          <svg class="document-toolbar__icon" width="24" height="24">
            <use :xlink:href= "statusIconDisabled" />
          </svg>
        </button>
      </div>
    </div>

    <div class="document-toolbar__set">
      <template v-if="card && !card.isChange">
        <button-watch
          :active="card.isWatched ? card.isWatched : false"
          :size="24"
          @click="onButtonWatchedClick"
        />
        <button-favorite
          :active="card.isFavorite ? card.isFavorite : false"
          :size="24"
          @click="onButtonFavoriteClick"
        />
      </template>

      <!--
      <button class="document-toolbar__button" :disabled="true">
        <router-link to="#" class="document-toolbar__link">
          <svg class="document-toolbar__icon" width="24" height="24">
            <use xlink:href="#document--canceled" />
          </svg>
        </router-link>
      </button>
      -->

      <button
        class="document-toolbar__button document-toolbar__search"
        :disabled="searchDisabled"
        @click="showDocumentSearch = !showDocumentSearch"
      >
        <svg class="document-toolbar__icon" width="24" height="24">
          <use xlink:href="#loupe" />
        </svg>
      </button>
      <document-search
        v-if="showDocumentSearch"
        :document-id="card.id"
        :current-view="currentView"
        @searchClose="onSearchClose"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ButtonFavorite from './ButtonFavorite';
import ButtonWatch from './ButtonWatch';
import DocumentSearch from './DocumentSearch';
import DocumentRoute from '@@/document/mixins/DocumentRoute';

export default {
  components: {
    ButtonFavorite,
    ButtonWatch,
    DocumentSearch
  },

  mixins: [DocumentRoute],

  props: {
    /** @type {Object|ApiDocumentCard|null} */
    card: {
      type: Object,
      default: null
    },
    currentView: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showDocumentSearch: false,
      searchQuery: ''
    };
  },

  computed: {
    ...mapGetters({
      winSize: 'getWindowSize'
    }),
    formatHtmlAvailable() {
      let card = this.card;

      return card && card.hasFormatHtml() && card.hasAccessFull();
    },
    formatScanAvailable() {
      let card = this.card;

      return card && card.hasFormatScan() && card.hasAccessFull();
    },
    searchDisabled() {
      return !(this.currentView === 'scan' || this.currentView === 'html');
    },
    documentStatuses() {
      return this.$store.state.documentStatuses;
    },
    statusIcon() {
      return this.card ? this.card.isRevision ? "#status--disabled" : this.card.getStatusIcon(this.documentStatuses) : null;
    },
    statusIconDisabled() {
      return "#status--disabled";
    },
    statusName() {
      return this.card ? this.card.getStatusName(this.documentStatuses) : null;
    },
    isBothViews() {
      return this.formatHtmlAvailable && this.formatScanAvailable;
    },
    bothViewsDisabled() {
      return !this.isBothViews || +this.winSize < 950;
    }
  },

  watch: {
    currentView(view) {
      if (view !== 'scan') {
        this.showDocumentSearch = false;
      }
    }
  },

  methods: {
    onButtonViewClick(viewCode) {
      this.$emit('button-view-click', viewCode);
    },
    onButtonFavoriteClick() {
      console.log(this.card.parentDocumentId);
      this.$emit('button-favorite-click', this.card.id, this.card.isFavorite);
    },
    onButtonWatchedClick() {
      this.$emit('button-watched-click', this.card.id, this.card.isWatched);
    },
    onButtonMainRevisionClick() {
      console.log(this.card.parentDocumentId);
    },
    onSearchClose() {
      this.showDocumentSearch = false;
    },
    attachmentDownload() {
      let config = this.$store.state.config;
      let apiUrl = config.apiUrl;
      document.location.href = apiUrl + '/documents/'+ this.card.id +'/export';
    }
  }
};
</script>
